/**
 * Команда воспроизведения слою: пауза, продолжить, сначала, перемотка.
 *
 * ЗАЧЕМ ЭТО ОТДЕЛЬНОЕ СООБЩЕНИЕ, А НЕ СВОЙСТВО СЛОЯ. Свойства —
 * это сцена: они хранятся, попадают в отмену и приезжают новому
 * зрителю снапшотом. Пауза не сцена, а состояние ЭТОГО проигрывателя
 * в ЭТУ минуту. Положи её в свойства — и она встанет в журнал,
 * в расклад и в снапшот, а зритель, подключившийся позже, получил бы
 * «ролик на паузе» как задуманное состояние эфира.
 *
 * ПЛАТА ЗА ЭТО НАЗВАНА ПРЯМО: команда не переживает переподключения.
 * Оверлей, перезапущенный в OBS, начнёт ролик заново — потому что
 * в сцене написано «играть», и это правда о сцене.
 *
 * Разбор общий у панели и оверлея: панель шлёт команду и применяет
 * её в своём предпросмотре, оверлей — в эфире. Две реализации
 * разошлись бы ровно там, где это дорого: в панели пауза,
 * в трансляции ролик играет.
 */
/*
ПЕРЕМОТКИ ЗДЕСЬ СНАЧАЛА НЕ БЫЛО, и отказ был записан так: «она
требует договориться о времени между панелью и оверлеем, а часы
у них не связаны ничем».

Довод оказался про другую задачу. Часы нужны, чтобы держать копии
ролика синхронными ПОСТОЯННО — то есть чинить расхождение, которое
накапливается само. Перемотка же называет позицию В САМОМ ФАЙЛЕ,
и стенные часы для этого не нужны вовсе: обе стороны ставят
`currentTime` в одно и то же число. Остаточная разница — это разброс
сетевой задержки между клиентами, десятки миллисекунд, и именно
перемотка эту разницу СХЛОПЫВАЕТ, а не создаёт.

Что по-прежнему верно: панель — это предпросмотр, а не зеркало.
Позиции копий никто не сверяет между собой, и оверлей, перезапущенный
в OBS, начинает ролик заново. Перемотка — единственный способ
привести их к одному числу, и в этом её главная польза, а не
в удобстве.
*/
/** Что можно сделать с роликом, не трогая сцену. */
import { decodeMessage } from './message.js';
const COMMANDS = new Set(['play', 'pause', 'restart', 'seek']);
/**
 * Предел позиции — сутки.
 *
 * Не про ролики: их таких не бывает. Про то, что число приходит
 * из сети и уходит прямо в `currentTime`, а бесконечность и NaN
 * там дают не перемотку, а неопределённое поведение проигрывателя.
 */
export const MAX_POSITION_MS = 24 * 60 * 60 * 1000;
/**
 * Разбирает сообщение `layerCmd`.
 *
 * Возвращает null для всего остального: вызывающий по этому понимает,
 * что сообщение не про воспроизведение, и передаёт дальше.
 */
export function parseLayerCommand(raw) {
    const parsed = decodeMessage(raw);
    if (parsed === null)
        return null;
    const message = parsed;
    if (message.t !== 'layerCmd')
        return null;
    if (typeof message.layerId !== 'string' || message.layerId === '')
        return null;
    if (typeof message.command !== 'string' || !COMMANDS.has(message.command))
        return null;
    const command = message.command;
    if (command !== 'seek') {
        return { layerId: message.layerId, command };
    }
    // Перемотка без позиции — это не перемотка: пропустить её значило бы
    // отправить ролик в начало, чего никто не просил
    const position = message.positionMs;
    if (typeof position !== 'number' || !Number.isFinite(position))
        return null;
    if (position < 0 || position > MAX_POSITION_MS)
        return null;
    return { layerId: message.layerId, command, positionMs: position };
}
/** Собирает сообщение для отправки. */
export function layerCommandMessage(layerID, command, positionMs) {
    if (command !== 'seek')
        return { t: 'layerCmd', layerId: layerID, command };
    return { t: 'layerCmd', layerId: layerID, command, positionMs: positionMs ?? 0 };
}
//# sourceMappingURL=layercmd.js.map